import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=10a3347d&"
import script from "./FullPage.vue?vue&type=script&lang=js&"
export * from "./FullPage.vue?vue&type=script&lang=js&"
import style0 from "./FullPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10a3347d')) {
      api.createRecord('10a3347d', component.options)
    } else {
      api.reload('10a3347d', component.options)
    }
    module.hot.accept("./FullPage.vue?vue&type=template&id=10a3347d&", function () {
      api.rerender('10a3347d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/FullPage.vue"
export default component.exports